<script>
    export default {
        name: "HomeInstructionTabs",
        props: {
            current: Number,
            end: Number,
        },
        methods: {
            clickHandler(index) {
                this.$emit("on-change", index);
            },
        },
    };
</script>

<template>
    <div class="home-instruction-tabs">
        <button
            class="home-instruction-tabs__trigger outline"
            :class="{ 'is-active': current === index }"
            v-for="index in end"
            :key="index"
            @click="clickHandler(index)"
        >
            {{ index }}
        </button>
    </div>
</template>

<style lang="scss">
    .home-instruction-tabs {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        @include bp($bp-desktop-sm) {
            justify-content: center;
            width: auto;
        }
    }

    .home-instruction-tabs__trigger {
        flex-shrink: 0;
        @include box(24px);
        margin: 0 2px;
        color: #fff;
        font-family: var(--secondary-font);
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        background-color: #bce7e5;
        border: 2px solid #bce7e5;
        border-radius: 50%;
        transition: transform 0.2s ease-in, background-color 0.2s ease-in,
            border-color 0.2s ease-in;
        &:hover,
        &:focus {
            border-color: #97dad6;
        }
        &.is-active {
            background-color: var(--primary--dark);
            border-color: var(--primary--dark);
            transform: scale(1.25);
        }
        @include bp($bp-desktop-sm) {
            @include box(32px);
            margin: 0 9px;
            font-size: 16px;
            line-height: 28px;
        }
    }
</style>
